import sigliveServiceV1 from 'Service/sigliveServiceV1';

const getSubscribeWebpush = async (subscribe) => {
  const { data } = await sigliveServiceV1({ method: 'POST', url: `/webpush/subscribe`, data: subscribe });

  return data?.data;
};

export default getSubscribeWebpush;
